import { ErrorHandler, Injectable } from '@angular/core';

import { MonitoringService } from './monitoring.service';

/**
 * Forwards errors caught by Angular's zone to Faro. Errors outside Angular
 * (script load failures, unhandled rejections in plain callbacks) are covered
 * by Faro's default window instrumentation; the SDK's dedupe prevents
 * double-reporting when both paths fire.
 */
@Injectable()
export class FaroErrorHandler extends ErrorHandler {
    constructor(private readonly monitoringService: MonitoringService) {
        super();
    }

    override handleError(error: unknown): void {
        this.monitoringService.trackError(error);
        super.handleError(error);
    }
}
